export default "__VITE_PUBLIC_ASSET__35f5ba74__"